// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'playerSearch';
export const selectPlayerSearchState = state => state[STORE_KEY];
export const selectPlayerSearchResults = state => selectPlayerSearchState(state).currentResults;
export const selectPlayerSearchQuery = state => selectPlayerSearchState(state).currentSearch;

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  currentSearch: {
    active: true,
    name: '',
  },
  currentResults: [],
};

const playerSearchReducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default playerSearchReducer;

// ------------------------------------
// Query
// ------------------------------------
export const QUERY = `${STORE_KEY}/QUERY`;
export const playerSearchQuery = ({ name, active = true }) => ({
  type: QUERY,
  payload: { active, name },
});
actions[QUERY] = (state, { payload }) => ({ ...state,
  currentSearch: {
    active: payload.active,
    name: payload.name,
  },
});

// ------------------------------------
// Response By name
// ------------------------------------
export const BY_NAME_RESPONSE = `${STORE_KEY}/BY_NAME_RESPONSE`;
export const playerSearchByNameResponse = ({ searchResults }) => ({
  type: BY_NAME_RESPONSE,
  payload: { searchResults },
});
actions[BY_NAME_RESPONSE] = (state, { payload }) => ({ ...state,
  currentResults: payload.searchResults,
});

// clear search field
export const CLEAR_PLAYER_SEARCH = `${STORE_KEY}/CLEAR_PLAYER_SEARCH`;
export const clearPlayerSearch = () => ({ type: CLEAR_PLAYER_SEARCH });
actions[CLEAR_PLAYER_SEARCH] = state => ({ ...state,
  currentSearch: {
    name: '',
  }
});



// WEBPACK FOOTER //
// ./src/store/reducers/playerSearch.js